<div
  class="tw-relative tw-flex tw-items-center tw-rounded-lg tw-p-3 tw-justify-between"
  [ngClass]="backgroundClass ? backgroundClass : 'tw-bg-dt-surface-elevated'"
>
  <div class="tw-flex tw-items-center tw-gap-2">
    <ng-content select="[main-icon]"></ng-content>

    <div class="tw-w-[90%]">
      <ng-content select="[title]"></ng-content>
    </div>
  </div>

  <button (click)="helperTooltip.toggle($event)">
    <svg class="tw-right-2 tw-h-7 tw-w-7 tw-text-dt-text-secondary xs:tw-h-5 xs:tw-w-5">
      <use [attr.xlink:href]="'images/sprite.svg#info-tooltip'"></use>
    </svg>
  </button>

  <div *ngIf="helperTooltip.showHelpTooltip" class="tooltip-container">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</div>
